import { useEffect } from "react";

export default function SEO({ title, description, favicon = "/logo.png" }) {
  useEffect(() => {
    document.title = title ? `${title} | Yansh Admin` : "Yansh Admin";

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description || "Yansh Technologies admin operations panel");

    let icon = document.querySelector('link[rel="icon"]');
    if (!icon) {
      icon = document.createElement("link");
      icon.setAttribute("rel", "icon");
      document.head.appendChild(icon);
    }
    icon.setAttribute("href", favicon);
  }, [description, favicon, title]);

  return null;
}
